import { render, staticRenderFns } from "./make-payment.vue?vue&type=template&id=6f2469ec&scoped=true&"
import script from "./make-payment.vue?vue&type=script&lang=js&"
export * from "./make-payment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f2469ec",
  null
  
)

export default component.exports